import {handleSendFunctionResponseToShotListAgent} from "../services/handleSendFunctionResponseToShotListAgent";

export const getSingleShot = async (index, updatedChatSession, shotListState, setChatSession, userInfo) => {
    const responseMessage = `FunctionResponse: The value of shot number ${index + 1} is "${JSON.stringify(shotListState?.[index])}".`
    const response = {
        role: "user",
        parts: [
          {
            text: responseMessage
          }
        ]
    };
    await handleSendFunctionResponseToShotListAgent(response, updatedChatSession, setChatSession, userInfo);
}